<template>
	<div class="signin">
		<div class="container mt-5">
			<div class="row justify-content-center">
				<div class="col-md-4 col-8 text-center">
					<h1 class="display-4">Prijava</h1>

					<form class="mt-4" @submit.prevent="signin">
						<div class="form-group">
							<input type="email" class="form-control" placeholder="Email" v-model="email">
						</div>
						<div class="form-group">
							<input type="password" class="form-control" placeholder="Šifra" v-model="password">
						</div>
						<button type="submit" class="btn btn-primary">Prijavi se</button>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { auth } from '../services/firebase';

export default {
	name: 'signin',

	data() {
		return {
			email: '',
			password: ''
		};
	},

	methods: {
		signin() {
			auth.signInWithEmailAndPassword(this.email, this.password)
				.then(() => {
					this.password = '';
				})
				.catch((error) => {
					this.$toasted.error('Nije uspela prijava. ' + error.toString(), {
						icon: 'error_outline'
					});
				});
		}
	}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// Signin.vue?1ef2b7b6